import React, { useEffect, useState } from 'react'
import { v4 as rid } from 'uuid'

import { client, urlFor } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'
import './About.scss'

const About = () => {
  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    const query = '*[_type == "about"] | order(_createdAt asc)'

    client.fetch(query).then(data => setAbouts(data))
  }, [])

  return (
    <>
      <h2 className="head-text">
        <span>I</span> am..
      </h2>
      <div className="app__about-portfolio">
        {abouts.map(about => (
          <div className="app__about-item app__flex" key={`about_${rid()}`}>
            <div className="app__about-img app__flex">
              <img src={urlFor(about.icon)} alt={about.name} />
            </div>

            <div className="app__about-content app__flex">
              <h4 className="bold-text">{about.name}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {about.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(About, 'app__about'))
